import { createContext } from 'react';

export interface SelectedTimestampContextType {
  selectedTimestamp: Date | null;
  setSelectedTimestamp: (timestamp: Date | null) => void;
}

export const SelectedTimestampContext = createContext<SelectedTimestampContextType | undefined>(undefined);

